import React, { FunctionComponent } from 'react';
import { ArticleBlockModel } from '../../../services/content/articleBody/models/ArticleBlockModel';
import { ImageBlockModel } from '../../../services/content/articleBody/models/ImageBlockModel';
import { EditorBlockModel } from '../../../services/content/articleBody/models/EditorBlockModel';
import { renderBody } from './services/ArticleRenderService';
import { AdsConfig } from '../ArticleHeading/models/AdsConfig';

type Props = {
    body: (ArticleBlockModel | ImageBlockModel | EditorBlockModel | null)[];
    adsConfig: AdsConfig[];
};

export const ArticleBody: FunctionComponent<Props> = ({ body, adsConfig }) => {
    return (
        <div className='pt-3 font-lato-400' id='woman-article-body'>
            {renderBody(body, adsConfig)}
        </div>
    );
};
